import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[kveToggleSection]'
})
export class ToggleSectionDirective implements AfterViewInit {
  toggleSections:HTMLCollection;

  constructor(private el:ElementRef) { }
  /**
   * Set default display for sketch-picker to none.
   * This ensures that only presets/theme options are shown.
   */  
  ngAfterViewInit(): void {
    let picker = this.el.nativeElement.querySelector('.sketch-picker');
    this.toggleSections = picker.children;
    console.log(this.el.nativeElement.querySelector('.sketch-picker'));
    this.togglePickerSections("none");
  }

  togglePickerSections(mode:string){
    for(let i = 0 ; i < this.toggleSections.length; i++){
      let sectionElement = <HTMLElement>this.toggleSections[i];
      console.log(sectionElement);
      if(sectionElement.classList.contains('sketch-saturation') || sectionElement.classList.contains('sketch-controls') || sectionElement.classList.contains('sketch-fields-container')){
        sectionElement.style.setProperty('display',mode);
        //sectionElement.classList.add('hide')
      }
    }
  }

  onChangeOption(e){
    console.log(e)
    if(e == "custom"){
      //this.firstOption.style.setProperty("background-color","");
      this.togglePickerSections("block");
    }else{
      this.togglePickerSections("none");
    }
  }

}
